import React, { useState } from "react";
import {
  Table,
  ButtonGroup,
  OverlayTrigger,
  Tooltip,
  Button,
  Modal,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import NoData from "../../components/no-data";
import moment from "moment";
import StatusChip from "../../components/statusChip";
import CommonActionDropDown from "../../components/common-action-dropdown";
import { MepEyeIcon, MoreVerticalIcon } from "../../assets/icons";
import { getUserInitial } from "../../components/common";
import { NpaAllPropertiesList } from "../../components/TableHeadings";
import { useDispatch } from "react-redux";
import {
  changePublicStatus,
  npaAllProperties,
} from "../../redux/slice/allPropertiesSlice";

const NpaListSection = ({
  data,
  navigate,
  currentPage,
  openDropdown,
  handleEditBtn,
  getCustomerActions,
  handleToggleDropdown,
}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handlePublicClick = (item, e) => {
    e.stopPropagation(); // prevent row click navigation
    setSelectedItem(item);
    setShowModal(true);
  };

  const confirmChange = () => {
    if (selectedItem) {
      // Dispatch changePublicStatus
      dispatch(
        changePublicStatus({
          id: selectedItem.id,
          is_public: !selectedItem.is_public,
        })
      ).then(() => {
        // Dispatch npaAllProperties to refresh the list
        dispatch(
          npaAllProperties({
            status: "", // Use the status you need
            page: currentPage,
            limit: 10, // Adjust limit as needed
            search: "", // Add any other filters you want
            is_public: null, // To fetch both public/private properties
          })
        );
      });
    }
    setShowModal(false);
    setSelectedItem(null);
  };

  return (
    <>
      {/* Table */}
      <Table responsive className="common-table">
        <thead>
          <tr>
            {NpaAllPropertiesList?.map((column, index) => (
              <th key={index}>{column.label}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data?.length === 0 ? (
            <NoData />
          ) : (
            data?.map((item, i) => (
              <tr
                key={item?.id}
                onClick={() =>
                  navigate(`/all-properties/property-details/${item?.id}`, {
                    state: { currentPage: currentPage },
                  })
                }
                className="cursor-pointer"
              >
                {/* Broker Details: Initials, Name, Mobile, Email */}
                <td>
                  {item?.broker ? (
                    <div className="d-flex align-items-center gap-2">
                      {/* Display Broker Initials */}
                      <div className="profile-icon">
                        {getUserInitial(
                          item?.broker?.first_name,
                          item?.broker?.last_name
                        )}
                      </div>

                      {/* Display Broker Details */}
                      <div className="ms-1">
                        <p className="fw-medium text-capitalize mb-1">
                          {item?.broker?.first_name} {item?.broker?.last_name}
                        </p>
                        <p className="mb-1" style={{ fontSize: "0.8rem" }}>
                          {item?.broker?.mobile_number || "-"}
                        </p>
                        <p className="mb-0" style={{ fontSize: "0.8rem" }}>
                          {item?.broker?.email || "-"}
                        </p>
                      </div>
                    </div>
                  ) : (
                    "-"
                  )}
                </td>

                {/* Property Type */}
                <td>{item?.property_type || "-"}</td>

                {/* Status */}
                <td>
                  {item?.status ? (
                    <StatusChip
                      bg={
                        item?.status === "Close"
                          ? "chip-warning"
                          : item?.status === "Live"
                          ? "chip-green"
                          : item?.status === "Open"
                          ? "chip-blue"
                          : item?.status === "Expired"
                          ? "chip-red"
                          : "custom-status-chip"
                      }
                      pill
                      title={item?.status}
                      className="text-capitalize"
                    />
                  ) : (
                    "-"
                  )}
                </td>

                {/* Transaction Type */}
                <td>{item?.transaction_type || "-"}</td>

                {/* Possession */}
                <td>{item?.possession || "-"}</td>

                {/* State */}
                <td>{item?.state?.name || "-"}</td>

                {/* City */}
                <td>{item?.city?.name || item?.district?.name || "-"}</td>
                
                {/* Locality */}
                <td>{item?.locality?.name || "-"}</td>

                {/* Image (if available) */}
                <td>
                  {item?.photos ? (
                    <img
                      src={item?.photos[0]?.url}
                      alt="property"
                      width={100}
                      height={75}
                    />
                  ) : (
                    <span>No Image</span>
                  )}
                </td>

                <td onClick={(e) => handlePublicClick(item, e)}>
                  <StatusChip
                    bg={item.is_public ? "chip-green" : "chip-red"}
                    pill
                    title={item.is_public ? "Publish" : "Unpublish"}
                    className="cursor-pointer"
                  />
                </td>
                
                {/* Type */}
                <td>{item?.type || "-"}</td>
                <td>{moment(item?.created_at).format("DD-MM-YYYY") || "-"}</td>

                {/* Action Buttons */}
                <td onClick={(e) => e.stopPropagation()}>
                  {/* <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-top`}>Edit</Tooltip>}
                  >
                    <span
                      onClick={() => handleEditBtn(item)}
                      className="mx-2 cursor-pointer"
                    >
                      <EditIcon
                        width={20}
                        height={20}
                        color="#6D6B77"
                        strokeWidth="4"
                      />
                    </span>
                  </OverlayTrigger> */}
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-top`}>View</Tooltip>}
                  >
                    <Link
                      to={`/all-properties/property-details/${item?.id}`}
                    >
                      <MepEyeIcon
                        width={20}
                        height={20}
                        color="#6D6B77"
                        strokeWidth="4"
                      />
                    </Link>
                  </OverlayTrigger>
                  <CommonActionDropDown
                    as={ButtonGroup}
                    id={`dropdown-basic-${i}`}
                    icon={
                      <MoreVerticalIcon
                        width={20}
                        height={20}
                        color="#6D6B77"
                        strokeWidth="4"
                      />
                    }
                    actions={getCustomerActions(item)}
                    show={openDropdown === i}
                    onToggle={() => handleToggleDropdown(i)}
                    className="action-menu"
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedItem?.is_public ? "Unpublish Property" : "Publish Property"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <p>
              {selectedItem.is_public
                ? "This Property will not be visible to other users once unpublished. Do you want to continue?"
                : "This Property will be visible to all users once published. Do you want to continue?"}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            No
          </Button>
          <Button variant="primary" onClick={confirmChange}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NpaListSection;
